// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingDeliveryPanel_root__22_I8","form":"EditListingDeliveryPanel_form__2i5zW","title":"EditListingDeliveryPanel_title__xmKvE"};